import { getKeycloakConfig } from './keycloakConfig';

/**
 * Builds the OIDC end-session URL. Omits `id_token_hint` — a stale hint causes
 * Keycloak "Invalid parameter: id_token_hint" after failed token refresh.
 */
export function buildKeycloakEndSessionUrl(redirectUri: string): string {
	const { url, realm, clientId } = getKeycloakConfig();
	const base = `${url.replace(/\/$/, '')}/realms/${realm}/protocol/openid-connect/logout`;
	const params = new URLSearchParams({
		client_id: clientId,
		post_logout_redirect_uri: redirectUri,
	});

	return `${base}?${params.toString()}`;
}
